import React from "react";
import "../../styles/SidebarGuideline.css";
 
const GuidelineWoman = () => {
  return (
    <div className="guideline-container">
      <h2 className="guideline-heading">Evaluation Guidelines – Woman Executive of the Year</h2>
     <br></br>
      <p><strong>Objective:</strong>Woman Executive of the Year in Oil and Gas industry honours a woman achiever for what she has done for the business and as a
mentor. It is a celebration of courage, grit, and professionalism.</p>
      <br></br>
      <p><strong>Eligibility criteria:</strong></p>
      <ul>
        <li>Service experience greater than 15 yrs.</li>
        <li>Only 2 nominations from an organization duly endorsed by CMD/MD in case of PSUs and CEO or equivalent senior executive of private Companies would be considered.</li>
        <li>Endorsement letter from the above-mentioned authorities to be submitted along with the application; failing which, application will
not be considered.</li>
      </ul>
      <br/>
      <p><strong>Evaluation Guideline:</strong>Evaluation will be done on basis of the responses mentioned by the Applicant in the input sheet. </p>
    </div>
  );
};
 
export default GuidelineWoman;